export const ItemStatus = {
  Pending: 'pending',
  Success: 'success',
  Error: 'error',
} as const;
export type ItemStatus = (typeof ItemStatus)[keyof typeof ItemStatus];

/**
 * Terminale Stati — werden vom Consumer per PATCH gesetzt. Weder
 * `pending` (initial, nur durch CREATE erreichbar) noch ein Wechsel
 * zwischen `success` und `error` ist erlaubt.
 */
export const TerminalItemStatus = {
  Success: ItemStatus.Success,
  Error: ItemStatus.Error,
} as const;
export type TerminalItemStatus = (typeof TerminalItemStatus)[keyof typeof TerminalItemStatus];
